import { isUndefined } from "lodash";
import React from "react";
import { type AccordionItemPropsInner } from "./Item";
import { AutoExpandItems } from "./component";

export const getHashValue = () => decodeURI(window.location.hash.replace(/^#/, ""));

export const getActiveItemIndices = (args: {
  activeItemIndex: number | undefined | null;
  autoExpand: AutoExpandItems | undefined;
  children: any | undefined;
  useHash: boolean | undefined;
}) => {
  if (!isUndefined(args.activeItemIndex)) {
    return args.activeItemIndex === null ? [] : [args.activeItemIndex!];
  }

  if (args.useHash) {
    const hash = getHashValue();
    if (hash) {
      const children = React.Children.toArray(args.children) as React.ReactElement<AccordionItemPropsInner>[];
      const index = children.findIndex((c) => c.props.hashKey === hash);
      if (index >= 0 && index < children.length) {
        return [index];
      }
    }
  }

  if (args.autoExpand === AutoExpandItems.All) {
    return Array.from({ length: args.children.length }, (_, i) => i);
  }

  return args.autoExpand === AutoExpandItems.First ? [0] : [];
};
